import { createFileRoute } from "@tanstack/react-router";
import { OwnershipTransfer } from "@/features/dashboard/ownership-transfer/OwnershipTransfer";

export const Route = createFileRoute("/_dashboard/ownership-transfer/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <OwnershipTransfer />;
}
